query cidadeSelect($where: CidadeModelFilterInput) {
    data: cidades(where: $where, order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}